import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import UserService from "../services/UserService";
import { Link, Navigate } from "react-router-dom";
import { AuthContext } from "../../context/auth.context";

class Login extends React.Component {
  app = this.props.app;

  static contextType = AuthContext;

  state = {
    redirectToReferrer: false,
    redirectToForgotPassword: false,
    email: "",
    password: "",
  };

  login = async () => {
    this.isAuthenticated = true;
    try {
      const loginResponse = await UserService.loginUser(this.state.email, this.state.password);

      sessionStorage.setItem("token", loginResponse.token);
      sessionStorage.setItem("userId", loginResponse.userId);
      this.context.login(loginResponse);

      setTimeout(
        this.setState(() => ({
          redirectToReferrer: true,
        })),
        500,
      );
    } catch (err) {
      this.app.handleSnackbarOpen(err, this.app.snackbarClassNames.ERROR);
    }
  };

  render() {
    var buttonStyle = {
      margin: "20px",
    };

    const { redirectToReferrer } = this.state;

    if (redirectToReferrer === true) {
      return (
        <Navigate
          to={{
            pathname:
              this.props.location &&
              this.props.location.state &&
              this.props.location.state.from &&
              this.props.location.state.from.pathname
                ? this.props.location.state.from.pathname
                : "/admin",
          }}
        />
      );
    }

    return (
      <div>
        <div
          style={{
            height: 80,
            width: "100vw",
            backgroundColor: "#FFF",
            boxShadow: "0px 0px 10px 2px #ccc",
            position: "relative",
          }}
        >
          <img
            style={{ position: "absolute", left: 20, top: 10 }}
            src="./Tracy_logo.png"
            alt="Tracy of Sweden"
            height="60"
            width="auto"
          />
        </div>
        <div className="HomeBody">
          <div className="ColumnCenter">
            <h3>You must log in to view the page!</h3>

            <TextField
              label="email"
              placeholder="example@company.se"
              variant="outlined"
              margin="normal"
              onChange={(event) => {
                this.setState({ email: event.target.value });
              }}
            />
            <TextField
              label="Password"
              type="password"
              autoComplete="current-password"
              onChange={(event) => this.setState({ password: event.target.value })}
            />

            <Button style={buttonStyle} variant="contained" color="primary" onClick={this.login}>
              Log in
            </Button>

            <Link to="/forgotPassword">Forgot your password ? Click here</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
